<template>
  <div class="w-full flex flex-col flex-grow items-center">
    <div class="w-full flex flex-col flex-grow max-w-4xl md:p-4"
         :class="[{'md:pt-0' : noPaddingTop}, {'md:pb-0' : noPaddingBottom}]">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  noPaddingTop?: boolean;
  noPaddingBottom?: boolean;
}>();
</script>
